<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 10:46:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refundlist/components/RefundListBtn/index.vue
-->
<template>
  <!-- 售后列表底部按钮 -->
  <div class="btn_con border_top1px">
    <div
      v-if="showDelete"
      class="font12 font_weight400 colo087 line_height_16 del_btn"
      @click="deleteAfter"
    >
      删除记录
    </div>
    <div
      class="font12 font_weight400 colof line_height_16 det_btn"
      @click="goRefundDetail"
    >
      查看详情
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: ""
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    goRefundDetail() {
      this.$emit("goRefundDetail", this.id);
    },
    deleteAfter() {
      this.$emit("deleteAfter", this.id);
    }
  }
};
</script>

<style lang="less" scoped>
.btn_con {
  background: #fff;
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
  .del_btn {
    border-radius: 2px;
    border: 1px solid #000;
    padding: 7px 18px 6px;
    box-sizing: border-box;
  }
  .det_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
    padding: 7px 18px 6px;
    margin-left: 8px;
  }
}
</style>
